import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthandregistryService } from '../../service/authandregistry.service';

@Component({
    selector: 'app-short-registration',
    standalone: false,
    templateUrl: './short-registration.component.html',
    styleUrl: './short-registration.component.scss'
})
export class ShortRegistrationComponent implements OnInit {
    // URL for development:
    // http://localhost:5261/login/short-registration?mail=rob@xuser.de&sid=0028ec0f-2a12-44ce-aaf9-be2d4adefa33&iid=8e612676-29bc-4ae8-ac83-d082563b1caa

    protected hidespinner: boolean = true;
    private route = inject(ActivatedRoute);
    private authAndRegistryService = inject(AuthandregistryService);

    ngOnInit(): void {

        this.route.queryParams.subscribe(async params => {
            const mail = params['mail'];    // E-Mail-Adresse aus den URL-Parametern
            const sid = params['sid'];   // Stream-ID aus den URL-Parametern
            const iid = params['iid'];   // Invitation-ID aus den URL-Parametern

            const password = crypto.randomUUID().slice(0, 12) + "!Aa1"; // Generiere ein zufälliges Passwort

            let result;
            if (!iid) {
                result = await this.authAndRegistryService.doRegister(mail, password, "Your company", undefined, true, sid)
            }

            if (iid) {
                result = await this.authAndRegistryService.registerByInviteId(mail, password, iid, true, sid)
            }
        });
    }

}
